export const ENUM_TYPE_IMAGE = {
    CARRE: 1,
    RECTANGLE: 2,
    PORTRAIT: 3
}